import { useEffect } from 'react';

export function registerForOutsideClick(ref, handler) {

  function documentClickHandler(event) {

    // Do nothing if clicking ref's element or descendent elements
    if (!ref.current || ref.current === event.target || ref.current.contains(event.target)) {
      // event.stopPropagation();
      return;
    }

    return handler(event);

  }

  document.addEventListener('mousedown', documentClickHandler);
  document.addEventListener('touchstart', documentClickHandler);

  return function unregisterEvents() {
    document.removeEventListener('mousedown', documentClickHandler);
    document.removeEventListener('touchstart', documentClickHandler);
  };

}

function useOnClickOutside(ref, handler) {

  useEffect(function onReferenceChange() {

    return registerForOutsideClick(ref, handler);
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
  }, [ref, handler]);

}

export default useOnClickOutside;